import React, { useState } from "react";
import {
  AppBar,
  createTheme,
  Tab,
  Tabs,
  ThemeProvider,
} from "@material-ui/core";
import { Security } from "./Security";
import { TabPanel } from "./Components/TabPanel/TabPanel";
import ConfigUser from "../ConfigUser";
import CardContainer from "../../../components/Card/CardContainer";

const tabTheme = createTheme({
  palette: {
    primary: {
      main: "#FAFAFA",
    },
  },
  overrides: {
    MuiTabs: {
      indicator: {
        backgroundColor: "black",
      },
      root: {
        borderBottom: "0.1px solid #F0F0F0",
        fontWeight: "bold",
        marginTop: "50px",
      },
    },
    MuiPaper: {
      elevation4: {
        boxShadow: "none",
      },
    },
    MuiTab: {
      root: {
        fontWeight: 700,
        fontSize: "14px",
        textTransform: "none",
        color: "#D3D3D3",
        "&$selected": {
          color: "black",
        },
      },
    },
  },
});

export default function Profile() {
  const [value, setValue] = useState(0);
  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue);
  };

  return (
    <>
      <CardContainer>
        <ThemeProvider theme={tabTheme}>
          <AppBar position="static">
            <Tabs value={value} onChange={handleChange} aria-label="tabs">
              <Tab label="Profile" />
              {/*   <Tab label="Manage Invites" /> */}
              <Tab label="Security" />
            </Tabs>
          </AppBar>
        </ThemeProvider>
      </CardContainer>
      <CardContainer>
        <TabPanel value={value} index={0}>
          <ConfigUser />
        </TabPanel>
        {/*  <TabPanel value={value} index={1}>
                Manage Invites Content
            </TabPanel> */}
        <TabPanel value={value} index={1}>
          <Security />
        </TabPanel>
      </CardContainer>
    </>
  );
}
